export const timesheetIndexRoute = '/timesheet';
export const crewTimesheetIndexRoute = '/crew-timesheets';

interface GetTimesheetRouteParams {
  staff?: boolean;
  includePrivate?: boolean;
}

const getQueryParams = (params: GetTimesheetRouteParams) => {
  const { staff, includePrivate } = params;
  const paramsString = new URLSearchParams();
  if (staff) {
    paramsString.append('staff', 'true');
  }
  if (includePrivate) {
    paramsString.append('includePrivate', 'true');
  }
  return paramsString.toString() ? `?${paramsString.toString()}` : '';
};

export const getTimesheetRoute = (id: string, params: GetTimesheetRouteParams = {}) => {
  return `${timesheetIndexRoute}/${id}${getQueryParams(params)}`;
};

export const getCrewTimesheetRoute = (id: string) => `${crewTimesheetIndexRoute}/${id}`;

export const getEntryModalTabRoute = (pathname: string, search: string, tab: string) => {
  const basePath = pathname.replace(/\/(details|approval-history)$/, '');
  return `${basePath}/${tab}${search}`;
};

interface GetCrewTimesheetEntryRouteParams {
  entity?: string;
  tab?: 'details' | 'approval-history';
  timesheetId: string;
}

export const getCrewTimesheetEntryRoute = (id: string, entryId: string, params: GetCrewTimesheetEntryRouteParams) => {
  const { tab = 'details' } = params;
  const query = new URLSearchParams({ timesheetId: params.timesheetId });
  if (params.entity) {
    query.set('entity', params.entity);
  }
  return `${getCrewTimesheetRoute(id)}/entry/${entryId}/${tab}?${query.toString()}`;
};

interface GetTimesheetEntryRouteParams extends Omit<GetTimesheetRouteParams, 'includePrivate'> {
  tab?: 'details' | 'approval-history';
}

export const getTimesheetEntryRoute = (id: string, entryId: string, params: GetTimesheetEntryRouteParams = {}) => {
  const { tab = 'details' } = params;
  return `${getTimesheetRoute(id)}/entry/${entryId}/${tab}${getQueryParams(params)}`;
};
